import { Atributo, AtributosEquivalencias, SaveAtributos, SaveValores } from '../types/index'
import { axiosInstanceIntegraciones } from '../../../utils/axiosGlobalUtils'
import { IProductoTienda } from '../types/responses-productos'
import { IBaseResponseGlobal } from '../types/responses'

export type BulkAtributosValoresResponse = Record<string, AtributosEquivalencias[]>

export const GetAtributosEquivalencias = async (tenant: string, codLocal: string) =>
  (
    await axiosInstanceIntegraciones.get<IBaseResponseGlobal<Atributo[]>>(
      `/${tenant}/locales/${codLocal}/equivalencias/atributos`
    )
  ).data

/**
 * Bulk — 1 sola request que trae valores de todos los atributos pedidos.
 * Reemplaza al viejo endpoint per-attr (que fue eliminado en el backend).
 */
export const GetAtributosEquivalenciasValoresBulk = async (tenant: string, codLocal: string, ids: number[]) =>
  (
    await axiosInstanceIntegraciones.get<IBaseResponseGlobal<BulkAtributosValoresResponse>>(
      `/${tenant}/locales/${codLocal}/equivalencias/atributos/valores?ids=${ids.join(',')}`
    )
  ).data

export const GetAtributos = async (tenant: string, codLocal: string) =>
  await axiosInstanceIntegraciones.get(`/${tenant}/locales/${codLocal}/equivalencias/atributos`)

export const SaveAtributosEquivalencia = async (tenant: string, atributos: SaveAtributos[], codLocal: string) =>
  await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/equivalencias/atributos`, atributos)

export const SaveValoresAtributos = async (tenant: string, valores: SaveValores[], codLocal: string) =>
  await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/equivalencias/atributos/valores`, valores)

export const ValidarAtributos = async (tenant: string, codLocal: string, productos: IProductoTienda[]) =>
  await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/equivalencias/atributos/validar`, productos)

export const DeleteAtributosEquivalencias = async (tenant: string, codLocal: string) =>
  await axiosInstanceIntegraciones.delete(`/${tenant}/locales/${codLocal}/equivalencias/atributos`)
